module.exports = __webpack_public_path__ + "bbf1acd2ac1fbd258bddb7179e493035.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/examples-3.png
// module id = 1686
// module chunks = 0